<template>
    <div class="dropzone form-control" ref="dropzone">
        <div class="dz-default dz-message">
            <i class="fa fa-camera" aria-hidden="true"></i>
            <a href @click.prevent="" class="d-block">{{ $t('Drop files here or click to upload.') }}</a>
        </div>
    </div>
</template>
<script>
    import Sortable from 'sortablejs';
    import Dropzone from 'dropzone';

    export default{
        props: {
            uploadUrl: {
                type: String,
                required: true
            },
            limit: {
                default: null,
            },
            paramName: {
                type: String,
                default: 'file'
            },
            params: {
              type: Object,
              default: ()  => {}
            },
            dataImages : {
                type: Array,
            },
            deleteUrl: {
                type: String,
                default: null
            },
            sortableUrl: {
                type: String,
                default: null
            }
        },
        methods: {
            loadImage(image) {
                // Create the mock file:
                var mockFile = {
                    name: "Filename",
                    size: 12345,
                    accepted : true,
                    removeUrl: this.deleteUrl?.replace(':id', image.id)
                };

                // Call the default addedfile event handler
                this.dropzone.emit("addedfile", mockFile);
                mockFile.previewElement.dataset.id = image.id;

                // And optionally show the thumbnail of the file:
                this.dropzone.emit("thumbnail", mockFile, image.full_path);

                // Or if the file on your server is not yet in the right
                // size, you can let Dropzone download and resize it
                // callback and crossOrigin are optional.
                // console.log(image.full_path);
                // this.dropzone.createThumbnailFromUrl(mockFile, image.full_path);


                // Make sure that there is no progress bar, etc...
                this.dropzone.emit("complete", mockFile);

                this.dropzone.files.push(mockFile);

                // If you use the maxFiles option, make sure you adjust it to the
                // correct amount:
                // var existingFileCount = 1; // The number of files already uploaded
                // this.dropzone.options.maxFiles = myDropzone.options.maxFiles - existingFileCount;
            },

            updateOrder(order) {
                if (this.sortableUrl) {
                    axios.post(this.sortableUrl, {
                        order: order.map((id) => parseInt(id, 10)),
                    }).then(function (response) {
                        console.log(response.data);
                    });
                }
            }
        },

        mounted () {
            Dropzone.autoDiscover = false;

            let element = this.$refs.dropzone;

            this.dropzone = new Dropzone(element, {
                url: this.uploadUrl,
                paramName: this.paramName,
                method: 'post',
                params: {
                    ...this.params,
                    _method: 'PUT'
                },
                addRemoveLinks: true,
                maxFiles: this.limit,
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken,
                    'X-Requested-With': 'XMLHttpRequest'
                },
                dictRemoveFileConfirmation: 'Do you want to remove this file?',
                init: () => {
                    if (this.sortableUrl) {
                        this.sortable = Sortable.create(element, {
                            draggable: ".dz-image-preview",
                            dataIdAttr: 'data-id',
                            onUpdate: () => {
                                this.updateOrder(this.sortable.toArray());
                            }
                        });
                    }
                }
            });

            this.dropzone.on("sending", (file, xhr, formData) => {
                // Will send the filesize along with the file as POST data.
                // formData.append("_method", 'PUT');
            });

            this.dropzone.on("removedfile", (file) => {
                if(file.removeUrl) {
                    axios.delete(file.removeUrl, {
                        params: {
                            ...this.params,
                        }
                    }).then((response) => {
                        this.$emit('updated')
                    });
                }
            });

            this.dropzone.on("maxfilesexceeded", (file) => {
                this.dropzone.removeFile(file);
            });

            this.dropzone.on('success', (file, response) => {
                file.id = response.id;
                file.full_path = response.full_path;
                file.removeUrl = this.deleteUrl?.replace(':id', response.id);
                file.previewElement.dataset.id = response.id;

                this.$emit('updated')
            });

            this.dataImages?.forEach((image) => this.loadImage(image));
        }
    }
</script>
<style>
    .dropzone{
        background: white;
        height: auto !important;
    }
    .dropzone .dz-preview .dz-image img{
        max-width: 100%;
        height: auto;
    }
</style>